import { graphqlClient } from "../../../client";
import cancelOrderDocument from "./cancelOrderMutation.graphql";
import type { OrderCancellationResultType } from "../../types";

export interface CancelOrderMutationVariables {
  command: {
    orderId: string;
    cancelReason?: string;
  };
}

export interface CancelOrderMutationResult {
  cancelOrder: OrderCancellationResultType;
}

export async function cancelOrder(
  orderId: string,
  cancelReason?: string,
): Promise<OrderCancellationResultType> {
  const { data } = await graphqlClient.mutate<CancelOrderMutationResult, CancelOrderMutationVariables>({
    mutation: cancelOrderDocument,
    variables: {
      command: {
        orderId,
        cancelReason,
      },
    },
  });

  return (
    data?.cancelOrder ?? {
      success: false,
      message: "Unknown error",
      refundedAmount: 0,
    }
  );
}
